<script setup>
import { ref, onMounted } from "vue"
import { useRoute } from "vue-router"
import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"
import PersianDate from "persian-date"
import * as persianTools from "@persian-tools/persian-tools"

import store from "../../state/store"

const title = "جزئیات فروشگاه"
const items = ref([
  {
    text: "فروشگاها",
    href: "/dashboard/stores",
  },
  {
    text: "جزئیات فروشگاه",
    active: true,
  },
])

const route = useRoute()
const id = route.params.id

const storeDetails = ref([])

onMounted(async () => {
  const { data } = await store.dispatch("getStore", id)
  storeDetails.value = {
    ...data.data,
  }
})

const toPersianDateTime = (date) => {
  const [datePart] = date.split(" ")
  const [year, month, day] = datePart.split("-")
  const gregorianDate = new Date(year, month - 1, day)
  const persianDate = new PersianDate(gregorianDate)
  return persianDate.format("YYYY/MM/DD")
}

const formattedPrices = (value) => {
  return new Intl.NumberFormat("fa-IR").format(value)
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-row>
      <b-col xxl="4">
        <b-card no-body>
          <b-card-body class="p-4">
            <div>
              <div class="flex-shrink-0 avatar-md mx-auto">
                <div class="avatar-title bg-light rounded">
                  <img
                    :src="
                      storeDetails.storeInfo
                        ? storeDetails.storeInfo.store_logo
                        : ''
                    "
                    alt=""
                    height="75"
                  />
                </div>
              </div>
              <div class="mt-4 text-center">
                <h5 class="mb-1">
                  {{ storeDetails ? storeDetails.name : "" }}
                </h5>
                <p class="text-muted">
                  {{
                    storeDetails.created_at
                      ? toPersianDateTime(storeDetails.created_at)
                      : ""
                  }}
                </p>
              </div>
              <div class="table-responsive">
                <table class="table mb-0 table-borderless">
                  <tbody>
                    <tr>
                      <th><span class="fw-medium">ایمیل</span></th>
                      <td>
                        {{ storeDetails.email ? storeDetails.email : "" }}
                      </td>
                    </tr>
                    <tr>
                      <th><span class="fw-medium">تلفن</span></th>
                      <td>
                        {{ storeDetails.phone ? storeDetails.phone : "" }}
                      </td>
                    </tr>
                    <tr>
                      <th><span class="fw-medium">اینستاگرام</span></th>
                      <td>
                        {{
                          storeDetails.storeInfo
                            ? storeDetails.storeInfo.instagram
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th><span class="fw-medium">واتساپ</span></th>
                      <td>
                        {{
                          storeDetails.storeInfo
                            ? storeDetails.storeInfo.whatsapp
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th><span class="fw-medium">ساعات کاری</span></th>
                      <td>
                        {{
                          storeDetails.storeInfo
                            ? storeDetails.storeInfo.working_hours
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th><span class="fw-medium">آدرس</span></th>
                      <td>
                        {{
                          storeDetails.storeInfo
                            ? storeDetails.storeInfo.store_address
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th><span class="fw-medium">شعار</span></th>
                      <td>
                        {{
                          storeDetails.storeInfo
                            ? storeDetails.storeInfo.slogan
                            : ""
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col xxl="8">
        <b-card no-body>
          <b-card-header class="border-0 align-items-center d-flex">
            <b-card-title class="mb-0 flex-grow-1">جزئیات فروش</b-card-title>
          </b-card-header>

          <b-card-header class="p-0 border-0 bg-soft-light">
            <b-row class="g-0 text-center">
              <b-col cols="6" sm="4">
                <div class="p-3 border border-dashed border-start-0">
                  <h5 class="mb-1">
                    {{
                      storeDetails.productCount
                        ? persianTools.digitsEnToFa(storeDetails.productCount)
                        : 0
                    }}
                  </h5>
                  <p class="text-muted mb-0">تعداد محصولات</p>
                </div>
              </b-col>
              <b-col cols="6" sm="4">
                <div class="p-3 border border-dashed border-start-0">
                  <h5 class="mb-1 text-success">
                    {{
                      storeDetails.totalPrice
                        ? formattedPrices(storeDetails.totalPrice)
                        : 0
                    }}
                  </h5>
                  <p class="text-muted mb-0">فروش</p>
                </div>
              </b-col>
              <b-col cols="6" sm="4">
                <div
                  v-if="storeDetails.id"
                  class="p-3 border border-dashed border-start-0 border-end-0"
                >
                  <RouterLink
                    :to="{
                      name: 'store.settlements',
                      params: { storeId: storeDetails.id },
                    }"
                  >
                    <h5 class="mb-1 text-danger">
                      {{
                        storeDetails.totalAmountDeposited
                          ? formattedPrices(storeDetails.totalAmountDeposited)
                          : 0
                      }}
                      -
                    </h5>
                    <p class="text-muted mb-0">برداشت شده</p>
                  </RouterLink>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
